module.exports = __webpack_public_path__ + "static/img/Dale-Finucane.0e55532.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Dale-Finucane.jpg
// module id = Skuc
// module chunks = 0